export default __webpack_public_path__ + "static/media/ms-kaleido.40701600.png";